export default {
    home: "Maison",
    order: {
        submit: "Réviser la commande"
    },
    tunnel: {
        loginVerification: "Vérification de connexion",
        addressVerification: "Vérification d'adresse"
    },
    catalog: "Catalogue",
    all: "Tous",
    return: {
        return: "Retour"
    },
    errors: {
        404: "@:views.errors.404.title"
    },
    impersonation: "Commander au nom de",
    approvals: "Approbations",
    delegate: "Délégués",
    employees: "Mes employés",
}